import React from "react";
import { groupByTp, formatBool, isPositive } from "./utils";

export default function TableComponent({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) {
  const levelLower = String(currentLevel || "").toLowerCase();
  const isNational = levelLower === "national";
  const isProvince = levelLower === "province";

  let levelName = "";
  if (isNational) {
    levelName = "Nasional";
  } else if (isProvince) {
    levelName = "Provinsi";
  } else if (levelLower === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  const faskesName = (() => {
    const data = reportInfo?.fasyankes;
    if (!data) return "Semua Fasyankes";
    const parts = data.split(",");
    const names = parts.map((part) => part?.split("|")[1] || part);
    return names.join(", ");
  })();

  const dataRows = reportsData ?? [];
  const groupedData = groupByTp(dataRows);

  return (
    <div className="table-table-responsive" ref={tableRef}>
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v3, LAPORAN TREN 2 DATA PEMANTAUAN JENTIK</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.statusPeriode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Periode
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1] || reportInfo?.province}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1] || reportInfo?.district}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>: {faskesName}</th>
          </tr>
        </tbody>
      </table>

      {groupedData.length > 0 ? (
        groupedData.map((group, groupIdx) => (
          <div
            key={group.tp_id ?? groupIdx}
            style={{
              marginTop: "24px",
              marginBottom: "24px",
            }}
          >
            <div
              data-export-group
              style={{
                marginBottom: "8px",
                lineHeight: "1.6",
                fontWeight: "600",
              }}
            >
              {isNational && <div>Provinsi: {group.info.provinsi}</div>}
              {(isNational || isProvince) && (
                <div>Kabupaten: {group.info.kabupaten}</div>
              )}
              <div>Puskesmas: {group.info.fasyankes}</div>
              <div>Desa: {group.info.desa}</div>
              <div>Nama Tempat Perindukan: {group.info.nama_tp}</div>
            </div>

            <table>
              <thead>
                <tr>
                  <th>Kunjungan</th>
                  <th>Tanggal Kunjungan</th>
                  <th>TP Positif</th>
                  <th>Jika Positif / IH</th>
                  <th>TP Masih Ada</th>
                  <th>Intervensi</th>
                  <th>TP Hilang karena Intervensi</th>
                </tr>
              </thead>
              <tbody>
                {group.visits.map((visit, vIdx) => (
                  <tr key={vIdx}>
                    <td>{visit?.kunjungan_ke ?? "-"}</td>
                    <td>{visit?.tanggal ?? "-"}</td>
                    <td>{formatBool(visit?.tp_positif)}</td>
                    <td>{isPositive(visit?.tp_positif) ? "100.0%" : "-"}</td>
                    <td>{formatBool(visit?.tp_masih_ada)}</td>
                    <td>{formatBool(visit?.ada_intervensi)}</td>
                    <td>{formatBool(visit?.hilang_karena_intervensi)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <table style={{ marginTop: "24px" }}>
          <tbody>
            <tr>
              <td colSpan={7}>Tidak Ada Data</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
